'use strict';
import VirtualScroll from 'virtual-scroll';
import {hasClass} from "./helpers";

const isTouchDevice = () => {
  return 'ontouchstart' in window || 'onmsgesturechange' in window;
};

export const scrolling = (() => {
  let header;
  let section;
  let scrollBar;
  const curPage = window.location.pathname + window.location.search + window.location.hash;
  const prevPage = window.localStorage.getItem('prevPage');
  let defEase = 0.08;
  let ease = defEase;
  let scroll = null;
  let barHeight = 0;
  let sectionHeight = 0;
  let currentY = 0;
  let targetY = 0;
  let isInit = false;

  const init = (wrapper = null) => {
    section = wrapper ? wrapper : document.querySelector('#scroller');
    header = document.querySelector('header');
    scrollBar = document.querySelector('.scrollBar__dot');
    if (isTouchDevice()) {
      document.querySelector('body').classList.add('is-touch-device')
    } else {
      start();
      eventListeners();
      window.shApp.scrollTop = 0;
      scroll.on((e) => {
        if (!hasClass(document.body, 'is-locked')) {
          changeTargetY(targetY + e.deltaY * 0.65);
        }
      });
      setBarSize();
      run();
    }
  };

  const destroy = () => {
    scroll.destroy();
  };



  const start = () => {
    targetY = (curPage === prevPage) ? parseInt(window.localStorage.getItem('scrollTop') || 0) : 0;
    sectionHeight = section.getBoundingClientRect().height;
    if (targetY < (sectionHeight - window.innerHeight) * -1) {
      targetY = (sectionHeight - window.innerHeight) * -1;
    }
    scroll = new VirtualScroll({
      el: window,
      firefoxMultiplier: 100,
      passive: false,
      useKeyboard: false
    });
    window.localStorage.setItem('prevPage', curPage);
    isInit = true;
  };

  const scrollTo = (y, isFast = false, isSmooth = false) => {
    const headerH = header.getBoundingClientRect().height;
    if (isInit) {
      if (isFast) {
        ease = 1;
      }
      if (isSmooth) {
        ease = 0.02;
      }
      changeTargetY(currentY - y + headerH);
      setTimeout(() => {
        ease = defEase;
      }, 100);
    } else {
      window.scrollBy(0, y - headerH);
    }
  };

  const changeTargetY = (newTargetY) => {
    sectionHeight = section.getBoundingClientRect().height;
    targetY = newTargetY;
    targetY = Math.max((sectionHeight - window.innerHeight) * -1, targetY);
    targetY = Math.min(0, targetY);
    window.localStorage.setItem('scrollTop', targetY);
  };

  const setBarSize = () => {
    barHeight = window.innerHeight * (window.innerHeight / sectionHeight);
    scrollBar.style['height'] = `${barHeight}px`;
  };

  const animPage = (y) => {
    section.style["transform"] = `translateY(${y}px) translateZ(0)`;
    section.style["webkitTransform"] = `translateY(${y}px) translateZ(0)`;
    section.style["mozTransform"] = `translateY(${y}px) translateZ(0)`;
    section.style["msTransform"] = `translateY(${y}px) translateZ(0)`;
  };

  const animScrBar = (y) => {
    const barTop = 2 + (window.innerHeight - barHeight - 4) * (Math.round(-10000 * (y) / (sectionHeight - window.innerHeight))) / 10000;
    scrollBar.style["transform"] = `translate3d(0, ${barTop}px, 0)`;
    scrollBar.style["webkitTransform"] = `translate3d(0, ${barTop}px, 0)`;
    scrollBar.style["mozTransform"] = `translate3d(0, ${barTop}px, 0)`;
    scrollBar.style["msTransform"] = `translate3d(0, ${barTop}px, 0)`;
  };

  const eventListeners = () => {
    window.addEventListener("load", function () {
      sectionHeight = section.getBoundingClientRect().height;
      setBarSize();
    });
    window.addEventListener("resize", function () {
      sectionHeight = section.getBoundingClientRect().height;
      setBarSize();
      changeTargetY(targetY);
    });
  };

  const run = function () {
    window.shApp.requestAnimation = requestAnimationFrame(run);
    const need = (targetY - currentY) * ease;
    currentY = (Math.abs(need) > 0.01) ? currentY + need : targetY;
    if (currentY > -0.001) currentY = 0;
    animPage(currentY);
    // animBlocks(currentY);
    animScrBar(currentY);
    if (Math.abs(currentY - targetY) > 0) {
      window.shApp.scrollTop = -1 * currentY;
    }
  };


  return {
    init,
    destroy,
    scrollTo
  }
})();
